export const escConfigs = {
    dropdown: {
        openSelector: ".dropdown.is-open",
        menuSelector: 'ul[role="list"]',
        openClass: "is-open",
        focusSelector: "button.btn",
    },
    search: {
        openSelector: ".search-results:not([hidden])",
        menuSelector: ".search-results",
        openClass: "noResults",
        focusSelector: 'input[type="search"]',
    },
};
